export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"preconnect","href":"https://fonts.gstatic.com/","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://fonts.googleapis.com/","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://fonts.googleapis.com/","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://fonts.gstatic.com/","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[],"title":"Epoca"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = true

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false